<template>
  <div :class="['alert', 'alert-' + type]">
    <strong>{{title}}</strong>
    <span v-html="message"/>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "alert",
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    type: {
      default: "info",
      type: String
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Messages/Alert.vue